<section class="pad">
    <br><br>
    <div class="sMbdrRad mat-elevation-z8">
        <h3 style="padding-left: 10px;">Incomplete Transactions</h3>
        <p style="padding-left: 10px;" *ngIf="arr.length < 1">No Incomplete Transaction</p>
        <table  *ngIf="arr.length > 0" mat-table [dataSource]="dataSource">

            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

            <!-- Position Column -->
            <ng-container matColumnDef="companyEmail">
                <th mat-header-cell *matHeaderCellDef>Initiator</th>
                <td mat-cell *matCellDef="let element"> {{element.companyEmail}} </td>
            </ng-container>

            <!-- Name Column -->
            <!-- <ng-container matColumnDef="commission">
                <th mat-header-cell *matHeaderCellDef>  </th>
                <td mat-cell *matCellDef="let element"> {{element.commission | currency:"NGN "}} </td>
            </ng-container> -->
            <!-- <ng-container matColumnDef="netPrice">
                <th mat-header-cell *matHeaderCellDef>  Net Price </th>
                <td mat-cell *matCellDef="let element"> {{element.netPrice | currency:"NGN "}} </td>
            </ng-container> -->

            <!-- Weight Column -->
            <ng-container matColumnDef="grossPremium">
                <th mat-header-cell *matHeaderCellDef class="gross"> Gross </th>
                <td mat-cell *matCellDef="let element" class="gross"> {{element.grossPremium | currency:"NGN "}} </td>
            </ng-container>

            <!-- commission Column -->
            
            <ng-container matColumnDef="numberOfDay">
                <th mat-header-cell *matHeaderCellDef class="duration"> Duration </th>
                <td mat-cell *matCellDef="let element" class="duration"> {{element.numberOfDay}} Days</td>
            </ng-container>
            <ng-container matColumnDef="updated_at">
                <th mat-header-cell *matHeaderCellDef class="date"> Date </th>
                <td mat-cell *matCellDef="let element" class="date"> {{element.updated_at | date:'medium'}} </td>
            </ng-container>
            <ng-container matColumnDef="_id">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let element">
                    <a routerLink="../policy-details/{{element._id}}/{{'chnl'}}" mat-button>View Details</a>
                     </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</section>